import { ESTADO_TIPO_PRESTAMOS } from "common/utils/constants"

export const getToggleButtons = (
  setTabSelected: $TSMigrationFixMe,
  t: $TSMigrationFixMe,
  clearRemesaSelection: $TSMigrationFixMe
) => {
  return [
    {
      id: 1,
      handleClick: () => {
        setTabSelected(ESTADO_TIPO_PRESTAMOS(t)[1].value)
        clearRemesaSelection?.()
      },
      label: `${ESTADO_TIPO_PRESTAMOS(t)[1].text}`,
      disabled: false,
    },
    {
      id: 2,
      handleClick: () => {
        setTabSelected(ESTADO_TIPO_PRESTAMOS(t)[2].value)
        clearRemesaSelection?.()
      },
      label: `${ESTADO_TIPO_PRESTAMOS(t)[2].text}`,
      disabled: false,
    },
  ]
}

export const getCheckStatus = (
  queryKey: $TSMigrationFixMe,
  selectedOptions: $TSMigrationFixMe
) => {
  return selectedOptions
    .filter((option: $TSMigrationFixMe) => option?.key === queryKey)[0]
    ?.query?.includes("true")
}

export const transformDataFromRemesasToRemesasPrestamos = (
  { facturaIds: arrayValues, ...data }: $TSMigrationFixMe,
  esAdeudo: $TSMigrationFixMe
) => ({
  prestamoIds: arrayValues,
  esAdeudo,
  ...data,
})

export const TYPE_DELETE_PRESTAMOS = {
  prestamos: 1,
  amortizaciones: 2,
}
